/**
 * This file defines metadata regarding the Quick Views and Saved Views in the Activity Log
 */
import { eventFields } from 'client/Insights/ActivityLog/constants/EventMetadata';
import EventTypes from 'client/Insights/ActivityLog/constants/EventTypes';

/**
 * A list of preset quick views names.
 * The value of the key-value pair is the name displayed to customers.
 */
export const quickViews = {
  adminActivity: 'Admin activity',
  adminCreatesAndDeletes: 'Admin creates and deletes',
  associationChanges: 'Association changes',
  loginAttempts: 'Login attempts',
  passwordChanges: 'Password changes',
  ssoAuths: 'Auths to SSO',
  systemCreatesAndDeletes: 'Device creates and deletes',
  userCreatesAndDeletes: 'User creates and deletes',
  userStateChanges: 'User state changes',
};

export const quickViewMetadata = {
  [quickViews.loginAttempts]: {
    additionalColumns: [eventFields.success, eventFields.service],
    filters: [
      {
        field: eventFields.eventType,
        value: [
          EventTypes.adminLoginAttempt,
          EventTypes.deviceTrustUserLoginAttempt,
          EventTypes.ldapBind,
          EventTypes.loginAttempt,
          EventTypes.radiusAuthAttempt,
          EventTypes.ssoAuth,
          EventTypes.userLoginAttempt,
        ],
      },
      {
        field: eventFields.success,
        value: [],
      },
    ],
  },
  [quickViews.passwordChanges]: {
    additionalColumns: [
      eventFields.resourceUsername,
      eventFields.resourceEmail,
      eventFields.service,
    ],
    filters: [
      {
        field: eventFields.eventType,
        value: [
          EventTypes.adminPasswordChange,
          EventTypes.userPasswordChange,
        ],
      },
      {
        field: eventFields.resourceUsername,
        value: [],
      },
      {
        field: eventFields.resourceEmail,
        value: [],
      },
    ],
  },
  [quickViews.userStateChanges]: {
    additionalColumns: [eventFields.resourceUsername],
    filters: [
      {
        field: eventFields.eventType,
        value: [
          EventTypes.userLockout,
          EventTypes.userActivated,
          EventTypes.userUnlocked,
          EventTypes.userPasswordExpired,
          EventTypes.userSuspended,
        ],
      },
      {
        field: eventFields.resourceUsername,
        value: [],
      },
    ],
  },
  [quickViews.associationChanges]: {
    additionalColumns: [
      eventFields.associationOperation,
      eventFields.associationToType,
      eventFields.associationFromType,
    ],
    filters: [
      {
        field: eventFields.eventType,
        value: [
          EventTypes.associationChange,
        ],
      },
      {
        field: eventFields.associationOperation,
        value: [],
      },
    ],
  },
  [quickViews.userCreatesAndDeletes]: {
    additionalColumns: [eventFields.resourceUsername],
    filters: [
      {
        field: eventFields.eventType,
        value: [
          EventTypes.userCreate,
          EventTypes.userDelete,
        ],
      },
    ],
  },
  [quickViews.systemCreatesAndDeletes]: {
    additionalColumns: [
      eventFields.resourceHostname,
      eventFields.resourceDisplayName,
    ],
    filters: [
      {
        field: eventFields.eventType,
        value: [
          EventTypes.systemCreate,
          EventTypes.systemDelete,
        ],
      },
    ],
  },
  [quickViews.adminCreatesAndDeletes]: {
    additionalColumns: [eventFields.resourceEmail],
    filters: [
      {
        field: eventFields.eventType,
        value: [
          EventTypes.adminCreate,
          EventTypes.adminDelete,
        ],
      },
      {
        field: eventFields.resourceEmail,
        value: [],
      },
    ],
  },
  [quickViews.ssoAuths]: {
    additionalColumns: [],
    filters: [
      {
        field: eventFields.eventType,
        value: [
          EventTypes.ssoAuth,
        ],
      },
      {
        field: eventFields.applicationName,
        value: [],
      },
    ],
  },
  [quickViews.adminActivity]: {
    additionalColumns: [
      eventFields.resourceEmail,
      eventFields.authMethod,
    ],
    filters: [
      {
        field: eventFields.initiatedByType,
        value: ['admin'],
      },
      {
        field: eventFields.resourceEmail,
        value: [],
      },
    ],
  },
};

// Add the name (the object key) to the object value
Object.keys(quickViewMetadata).forEach((viewName) => {
  quickViewMetadata[viewName].name = viewName;
  quickViewMetadata[viewName].isQuickView = true;
});

export default {
  quickViewMetadata,
  quickViews,
};
